import script from "./commentInfoList.vue?vue&type=script&setup=true&lang=js"
export * from "./commentInfoList.vue?vue&type=script&setup=true&lang=js"

import "./commentInfoList.vue?vue&type=style&index=0&id=2d8d2b02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d8d2b02"]])

export default __exports__